import { VendorSubscriptionLookupData } from '../../../../shared/types';
import {
  VendorActiveSubscriptionDisplay,
  buildVendorActiveSubscriptionDisplayVm,
} from './vendor-active-subscription-display.util';

/**
 * @param fallbackLicensePlate Plate of the vehicle in the current order request,
 *   used when the vendor's customer record carries no plate of its own. Expected
 *   pre-normalized (plate only, no state code).
 */
export function buildVendorActiveSubscriptionDisplayFromLookup(
  data: VendorSubscriptionLookupData,
  fallbackLicensePlate = ''
): VendorActiveSubscriptionDisplay {
  const customer = data.customer;
  const subscription = data.subscription;

  const flat: Record<string, any> = {
    customer,
    subscription,
    customer_first_name: customer?.first_name,
    customer_last_name: customer?.last_name,
    customer_source: customer?.source,
    source: customer?.source ?? subscription?.source,
    package_name: subscription?.package_name,
    package_id: subscription?.package_id,
    total_washes_available: subscription?.total_washes_available,
    total_washes_redeemed: subscription?.total_washes_redeemed,
    last_washed_date: subscription?.last_washed_date,
    license_plate: data.vehicle?.license_plate ?? customer?.license_plate ?? fallbackLicensePlate,
    state: data.vehicle?.state ?? customer?.vehicle_state,
    order_id: data.order_id ?? subscription?.order_id,
    payment_status: data.payment_status,
    payment_required: data.payment_required,
    has_payment: data.has_payment,
    card_details_collected: data.card_details_collected ?? data.cardDetailsCollected,
    cardDetailsCollected: data.cardDetailsCollected ?? data.card_details_collected,
    recurring_monthly_price: data.recurring_monthly_price,
    amount_due_today: data.amount_due_today,
    final_price: data.amount_due_today ?? data.final_price,
    list_price: data.recurring_monthly_price ?? data.list_price,
    membership_start_date: data.membership_start_date ?? data.billing_starts_at,
    billing_starts_at: data.billing_starts_at ?? data.membership_start_date,
    current_period_start: subscription?.current_period_start,
    current_period_end:
      data.membership_start_date ?? data.billing_starts_at ?? subscription?.current_period_end,
    customer_contact: customer?.contact,
    contact: customer?.contact,
  };

  const display = buildVendorActiveSubscriptionDisplayVm(flat);
  if (display.licensePlate === '—' && fallbackLicensePlate.trim()) {
    return {
      ...display,
      licensePlate: fallbackLicensePlate.trim().toUpperCase(),
    };
  }
  return display;
}
